module.exports = __webpack_public_path__ + "static/media/niivana-logo.10d75378.png";